module.exports = __webpack_public_path__ + "static/img/Easy报表_0.3f28375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Easy报表_0.jpg
// module id = Bg3x
// module chunks = 1